// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__4pHY4","container":"SectionHeader_container__5kWTV","header__heading":"SectionHeader_header__heading__5kCMI"};